import { z } from "zod";
import apiClient from "../../../shared/api/client";

const adminProfileSchema = z.object({
  id: z.string(),
  username: z.string(),
  email: z.string().email(),
});

export type AdminProfile = z.infer<typeof adminProfileSchema>;

export type UpdateProfileInput = {
  username: string;
};

export const updateAdminProfile = async (input: UpdateProfileInput): Promise<AdminProfile> => {
  const response = await apiClient.put("/admin/profile", input);
  return adminProfileSchema.parse(response.data);
};

export type ChangePasswordInput = {
  currentPassword: string;
  newPassword: string;
};

export const changeAdminPassword = async (input: ChangePasswordInput): Promise<void> => {
  await apiClient.put("/admin/profile/password", input);
};

export const getTwoFactorStatus = async (): Promise<{ twoFactorEnabled: boolean }> => {
  const response = await apiClient.get("/admin/profile/2fa/status");
  return response.data;
};

export const setupTwoFactor = async (): Promise<{ qrCodeUrl: string; secret: string }> => {
  const response = await apiClient.post("/admin/profile/2fa/setup");
  return response.data;
};

export const verifyTwoFactorSetup = async (code: string): Promise<{ success: boolean }> => {
  const response = await apiClient.post("/admin/profile/2fa/verify-setup", { code });
  return response.data;
};

export const disableTwoFactor = async (code: string): Promise<{ success: boolean }> => {
  const response = await apiClient.post("/admin/profile/2fa/disable", { code });
  return response.data;
};
